




























import Vue, { PropOptions } from 'vue';
import utilComponents from '@/components/util';
import NOC from '@/class/common/const';

import SelectBox from '@/components/util/NewSelectBox.vue';

export default Vue.extend({
  name: 'ModalMigrateConfirm',
  components: {
    ...utilComponents, SelectBox,
  },
  props: {
    name: String,
    member_num: Number,
    optionsWorkStyle: {
      type: Array,
      default: [NOC.SELECT.FIRST],
    },
  },
  data() {
    return {
      // value: '',
      inputedSearchWorkstyle: 0,
    };
  },
  methods: {
    onClickDelete() {
      this.$emit('onClickDelete');
      this.$emit('close');
    },
    onClickClose() {
      this.$emit('close');
    },
    deleteWorkStyle() {
      this.$emit('deleteWorkStyle', this.inputedSearchWorkstyle);
      this.$emit('close');
    },
  },
});
